import {CodeViewError} from '@github-ui/code-view-shared/components/CodeViewError'
import {ActionProvider} from '@github-ui/code-view-shared/contexts/ActionContext'
import {CopilotSettingsProvider} from '@github-ui/code-view-shared/contexts/CopilotSettingsContext'
import {EditPermissionsProvider} from '@github-ui/code-view-shared/contexts/EditPermissionsContext'
import {PathProvider} from '@github-ui/code-view-shared/contexts/PathContext'
import {RefInfoProvider} from '@github-ui/code-view-shared/contexts/RefInfoContext'
import {useCanonicalObject} from '@github-ui/code-view-shared/hooks/use-canonical-object'
import type {DataRouterErrorPayload} from '@github-ui/code-view-types'

import {useUpdateRefInfoAndPath} from '../hooks/use-update-ref-info-and-path'

export function CodeViewRepoErrorPage({payload}: {payload: DataRouterErrorPayload}) {
  const refInfo = useCanonicalObject(payload.refInfo)
  useUpdateRefInfoAndPath(refInfo, payload.path)

  return (
    <PathProvider path={payload.path}>
      <ActionProvider action="tree">
        <CopilotSettingsProvider
          copilotAccessAllowed={payload.copilotAccessAllowed ?? false}
          copilotSpacesEnabled={payload.copilotSpacesEnabled ?? false}
        >
          <RefInfoProvider refInfo={refInfo}>
            <EditPermissionsProvider
              canEdit={refInfo.canEdit}
              canEditOnDefaultBranch={refInfo.canEditOnDefaultBranch}
              fileExistsOnDefault={refInfo.fileExistsOnDefault}
            >
              <CodeViewError {...payload.error} />
            </EditPermissionsProvider>
          </RefInfoProvider>
        </CopilotSettingsProvider>
      </ActionProvider>
    </PathProvider>
  )
}
